import { useStoreNotifications } from '@/Store/storeNotifications';

export function setNotificationInvisibleAfterTimeInSeconds(notificationId: string, time: number) {
    const notification = useStoreNotifications().notifications
        .find(item => item.id === notificationId);

    if (!notification) {
        return;
    }

    function setInvisible() {
        useStoreNotifications().setNotificationVisibleById(notificationId, false);
    }

    setTimeout(setInvisible, time * 1000);
}
